module.exports = __webpack_public_path__ + "img/top_arrow.e439610.png";